module.exports = __webpack_public_path__ + "img/vertical_4_3_7042.8cc3e49f.png";